import { featuresByCountry } from '../utils/getInitialFeatures';
import { isClientSide } from '../../utils/ssrUtils';

export const defaultState = {
  features: featuresByCountry,
  country: (isClientSide && window.COUNTRY_CODE) || 'fr',
};

export function featuresReducer(state = defaultState) {
  return state;
}
